import { render, staticRenderFns } from "./AI.vue?vue&type=template&id=fb7b0436&scoped=true"
import script from "./AI.vue?vue&type=script&lang=js"
export * from "./AI.vue?vue&type=script&lang=js"
import style0 from "./AI.vue?vue&type=style&index=0&id=fb7b0436&prod&scoped=true&lang=scss"
import style1 from "./AI.vue?vue&type=style&index=1&id=fb7b0436&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7b0436",
  null
  
)

export default component.exports